import { API } from "../../../API";
import { AgencyId } from "../../../messages";
import { retryableModalNetworkRequest } from "../../../NetworkRequest";
import { AppState } from "../../../system/AppState";

export async function cancelAgencyRequest(
  agencyId: AgencyId,
  api: API,
  appState: AppState
): Promise<void> {
  await retryableModalNetworkRequest(() => {
    return api.cancelAgencyRequested(agencyId);
  }, true);

  // To delete old agency chats (TODO reconsider)
  appState.chatState.triggerFullRefresh();
}
